<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Configuración de examen</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Código</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="test.code" 
                                    />
                                    <small v-if="submitted && v$.test.code.$error" class="text-danger">Código de examen es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Descripción</label
                                    >
                                    <argon-input type="text" v-model="test.description" />
                                    <small v-if="submitted && v$.test.description.$error" class="text-danger">Descripción de examen es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Clasificación</label
                                    >
                                    <argon-select class="form-control" type="text" v-model="test.clasification_id" :choices="testClasifications"/>
                                    <small v-if="submitted && v$.test.clasification_id.$error" class="text-danger">Clasificación de examen es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Tipo de muestra biológica</label
                                    >
                                    <argon-select class="form-control" type="text" v-model="test.type" :choices="testTypes"/>
                                    <small v-if="submitted && v$.test.type.$error" class="text-danger">Tipo de muestra biológica es requerido</small>
                                </div>
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Instrucciones</label
                                    >
                                    <argon-textarea type="text" v-model="test.instructions"/>
                                </div>
                            </div>
                            <div class="row">
                                <ul class="nav nav-tabs nav-fill" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="test-params" ref="pcparams" data-bs-toggle="tab" data-bs-target="#params" type="button" role="tab" aria-controls="params" aria-selected="true">Indicadores generales</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="test-suplies" ref="pcsuplies" data-bs-toggle="tab" data-bs-target="#suplies" type="button" role="tab" aria-controls="suplies" aria-selected="false">Insumos</button>
                                    </li>
                                </ul>
                                <div class="tab-content" id="myTabContent">
                                    <div class="tab-pane fade show active" id="params" role="tabpanel" aria-labelledby="params-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="example-text-input" class="form-control-label"
                                                        >Nombre</label
                                                        >
                                                        <argon-input id="code"
                                                        type="text" v-model="testParams.name" 
                                                        />
                                                    </div> 
                                                    <div class="col-md-2">
                                                        <label for="example-text-input" class="form-control-label"
                                                        >Unidad de Medida</label
                                                        >
                                                        <argon-input id="code"
                                                        type="text" v-model="testParams.unit" 
                                                        />
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label for="example-text-input" class="form-control-label"
                                                        >Tipo de resultado</label
                                                        >
                                                        <argon-select class="form-control" type="text" v-model="testParams.type_reference" :choices="typeReferences"/>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <argon-button 
                                                        class="mt-4"
                                                        variant="gradient"
                                                        color="info"
                                                        fullWidth
                                                        size="lg"
                                                        @click="insertParam"
                                                        >Agregar indicador</argon-button>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="card">
                                                            <div class="card-header pb-0">
                                                                <div class="row">
                                                                    <div class="col-md-10">
                                                                        <h6>Indicadores</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-body px-0 pt-0 pb-2">
                                                                <div class="table-responsive p-0">
                                                                    <table class="table align-items-center mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th
                                                                                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                                                                                >Nombre</th>
                                                                                <th
                                                                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                                                                                >Unidad de Medida</th>
                                                                                <th
                                                                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                                                                                >Tipo de resultado</th>
                                                                                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr 
                                                                                v-for="(
                                                                                {
                                                                                    name,
                                                                                    unit,
                                                                                    type_reference
                                                                                },
                                                                                index
                                                                                ) of testParamsRows"
                                                                                :key="index"
                                                                            > 
                                                                                <td>
                                                                                    <div class="d-flex px-2 py-1">
                                                                                        <div class="d-flex flex-column justify-content-center">
                                                                                            <h6 class="mb-0 text-sm">{{ name }}</h6>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div class="d-flex px-2 py-1">
                                                                                        <div class="d-flex flex-column justify-content-center">
                                                                                            <h6 class="text-xs font-weight-bold mb-0 text-center">{{ unit }}</h6>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div class="d-flex px-2 py-1">
                                                                                        <div class="d-flex flex-column justify-content-center text-center">
                                                                                            <h6 class="mb-0 text-sm" v-if="type_reference==0">Cuantitativo</h6>
                                                                                            <h6 class="mb-0 text-sm" v-if="type_reference==1">Cualitativo</h6>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td >
                                                                                    <div class="d-flex px-2 py-1">
                                                                                        <div class="d-flex flex-column justify-content-center text-center">
                                                                                            <a
                                                                                                @click="removeParam(index)"
                                                                                                class="btn btn-xs bg-gradient-danger"
                                                                                            >Quitar</a>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                    
                                    </div>
                                    <div class="tab-pane fade show " id="suplies" role="tabpanel" aria-labelledby="suplies-tab">
                                    </div>
                                </div>
                            </div>
                            <argon-button
                            type="submit" 
                            class="mt-4"
                            variant="gradient"
                            color="info"
                            fullWidth
                            size="lg"
                            @click="insertTest"
                            >Guardar</argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSelect from "@/components/ArgonSelect.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import {useVuelidate} from '@vuelidate/core';
import {required} from  '@vuelidate/validators';
import axios from "axios";

export default {
    name: "company",
    setup:() => ({ v$: useVuelidate() }), 
    data() {
        return {
            showMenu: false,
            submitted:false,
            testClasifications:[],
            testTypes:[],
            test:{
                action:'add',
                object:'test',
                code:null,
                description:null,
                clasification_id:null,
                type:null,
                instructions:null,
                company_id:1
            },
            testParams:{
                action:'add',
                object:'test_details',
                test_id:0,
                name:null,
                unit:null,
                type_reference:0
            },
            typeReferences:[
                {value:0,text:'Cuantitativo'},
                {value:1,text:'Cualitativo'}
            ],
            testParamsRows:[],
        };
    },
    components: {
        ArgonInput, 
        ArgonButton, 
        ArgonTextarea, 
        ArgonSelect,
    },
    validations(){
        return{
            test:{
                code:{required},
                description:{required},
                clasification_id:{required},
                type:{required},
            },
        }
    },
    methods:{
        async fetchTestClasifications(config){
            let self=this;
            fetch(this.$store.state.apiURL+'?action=list&object=test_clasifications&recperpage=all', config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result);
                this.testClasifications=result.test_clasifications.map(item=>{return{value:item.id, text:item.description}})
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        async fetchTestTypes(config){
            let self=this;
            fetch(this.$store.state.apiURL+'?action=list&object=test_types&recperpage=all', config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result);
                this.testTypes=result.test_types.map(item=>{return{value:item.id, text:item.description+' - Conservable hasta '+item.max_live+' Horas'}})
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        insertTest(){
            let self= this;
            this.submitted = true;
            this.v$.$touch();
            if(!this.v$.$invalid){
                const token = localStorage.getItem("accessToken");
                const config = {headers: {"Authorization": `Bearer ${token}`}};
                console.log(this.test)
                axios.post(this.$store.state.apiURL, this.test, config)
                .then((result)=>{
                    console.log(result);
                    this.testParamsRows.forEach(function (item){
                        item.test_id= result.data.test.id
                    })
                    let request = this.testParamsRows.map(items=> axios.post(this.$store.state.apiURL,items, config));
                    axios.all(request)
                    .then((resultAll)=>{
                        console.log(resultAll)
                        self.$swal({
                            title: 'Actualización de datos',
                            text: 'Se insertó la información del examen de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#bf4f51',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            self.$router.push('/test-settings');
                        });
                    })
                    
                })
            }else{
                self.$swal({
                    title: 'Error en validación',
                    text: 'Encontramos algunos datos incorrectos',
                    type: 'error',
                    icon:'error',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                });
            } 
            
        },
        insertParam(){
            let testParam= {
                name:this.testParams.name,
                unit:this.testParams.unit,
                action:this.testParams.action,
                object:this.testParams.object,
                type_reference:this.testParams.type_reference,
            };
            this.testParamsRows.push(testParam);
            this.testParams.name=null;
            this.testParams.unit=null;
        },
        removeParam(indexVal){
            console.log(indexVal)
            this.testParamsRows.splice(indexVal);
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"Authorization": `Bearer ${token}`}};
        this.fetchTestClasifications(config);
        this.fetchTestTypes(config);
    },
    beforeMount() {

    },
    beforeUnmount() {

    }
};
</script>